import React from "react";
import Select from "react-select";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { truncate } from "lodash";
import queryString from "query-string";

const JobPicker = ({
  jobNumber,
  value,
  onChange,
  placeholder = "Select Job...",
  ...props
}) => {
  const { backendUrl } = useAuth();
  const fetchJobs = async queryParams => {
    // await waitFor(5000);
    let response = await fetch(
      `${backendUrl}/api/job?&${queryString.stringify(queryParams)}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    data.jobs = data.jobs.map(el => ({
      ...el,
      value: el.jobNumber,
      label: el.title,
    }));

    return data;
  };

  const {
    data = { count: 0, jobs: [], milestones: [] },
    isFetching,
    error,
    isLoading,
  } = useQuery(["JOBS"], () => fetchJobs(), {
    keepPreviousData: true,
  });

  try {
    // Find the selected option to get the proper label
    const selectedOption =
      data?.jobs?.find(option => option.value === value) || null;

    return (
      <Select
        value={selectedOption}
        onChange={onChange}
        options={data?.jobs || []}
        isLoading={isLoading}
        isDisabled={isLoading}
        placeholder={placeholder}
        isClearable
        isSearchable
        loadingMessage={() => "Loading jobs..."}
        noOptionsMessage={() =>
          error ? "Error loading jobs" : "No jobs found"
        }
        classNamePrefix="form-select"
        {...props}
      />
    );
  } catch (error) {
    console.error("Error in JobPicker:", error);
    return <p>Error loading jobs</p>;
  }
};

export default JobPicker;
